import { Form, Space, Col, Popover, Switch, TableColumnType } from "antd";
import moment from "moment";
import React from "react";
import { BillingCategoryName } from "../../../models/billingCategory";
import { DateTimeFormat, DateTimeFormatSimple } from "../../../models/datetime";
import { Dimen } from "../../../models/dimen";
import { ColDef } from "ag-grid-community";
import styles from './recardDurg.module.css'
import { Checks } from "../../../models/setting";
import { useSelector } from "react-redux";
import { selectSettings } from "../../user/setting/settingSlice";

// 药品购进记录
export const AGColumns = (
  startIndex?: any,
  receiptDetail?: (id: any) => void,
  columnList?: any,
  cell?: any,
  KFGZZCKLRSJData?: any,
): ColDef[] => {
  const settings = useSelector(selectSettings)

  // 新老目录展示方式 (老目录没有区分药品类别/无型号)
  const getProcuctInfo = (item: any) => {
    const materialsCategory = item.materialsCategory
    const packSpec = item.packSpec ? item.packSpec : '暂无'
    const spec = item.spec ? item.spec : '-'
    const doseCategory = item.doseCategory ? item.doseCategory : '-'
    const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'
    const model = item.model ? '/' + item.model : ''

    if (settings?.[Checks.MLKG] == 1) {
      if (materialsCategory == '0') {
        // 生产厂家 + 包装规格 + 剂型 
        return tenantSupplierName + '/' + packSpec + '/' + doseCategory
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 生产厂家 + 包装规格 +  型号 
        return tenantSupplierName + '/' + packSpec + model
      } else {
        // 生产厂家 + 包装规格 
        return tenantSupplierName + '/' + packSpec
      }
    } else {
      if (materialsCategory == '0') {
        // 生产厂家 + 包装规格 + 剂型 
        return tenantSupplierName + '/' + packSpec + '/' + doseCategory
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 生产厂家 + 规格 +  型号 
        return tenantSupplierName + '/' + spec + model
      } else {
        // 生产厂家 + 规格 
        return tenantSupplierName + '/' + spec
      }
    }
  }

  return (
    columnList?.map((item: any) => {
      // 根据注释掉的列配置，补充 cellRendererFramework 或 valueFormatter
      switch (item.field) {
        case 'index':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) {
                return ''
              }
              return `${Number(startIndex || 0) + params.node.rowIndex + 1}`
            },
          };
        case 'putNumber': // 业务单号
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: function getPutNumber(params: any) {
              const record = params.data;
              if (params.node.rowPinned) return '';
              return (
                <a onClick={() => {
                  receiptDetail && receiptDetail(record.tenantInventoryReceiptId)
                }} style={{ cursor: 'pointer', width: '100%', height: '100%', alignItems: 'center', display: 'flex', margin: 'auto' }}> {record.putNumber} </a>
              );
            }
          };
        case 'producInfo': //产品信息
          return {
            ...item,
            headerClass: styles.leftAligned,
            cellStyle: { textAlign: 'left' },
            cellRendererFramework: function getProducInfo(params: any) {
              const record = params.data;
              if (params.node.rowPinned) return '合计';
              return <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Col>
                  <Popover
                    content={
                      <div style={{ height: '55px' }}>
                        <p className={styles.nameText}>
                          {record.name}
                        </p>
                        <p className={styles.productText}>
                          {getProcuctInfo(record)}
                        </p>
                      </div>
                    }
                    placement='bottom'
                  >
                    <div
                      style={{ height: '55px', width: '300px', overflow: 'hidden' }}
                    >
                      <p
                        className={styles.nameText}
                      >
                        {record.name}
                      </p>
                      <p
                       className={styles.productText}
                      >
                       {getProcuctInfo(record)}
                      </p>
                    </div>
                  </Popover>
                </Col>
              </Space>
            },
          };
        case 'no': //商品编码
        case 'spec': //制剂规格
        case 'doseCategory': //剂型
        case 'genericName': //通用名
        case 'origin': //产地
        case 'hilistCode': //医保国码
        case 'batchNo': //批次号
        case 'approvalNumber': //批准文号
        case 'storehouseName': //库房名称
        case 'supplierName': //供应商
        case 'userName': //采购人员
        case 'invoiceNb': //发票号
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              const field = item.field;
              const val = t?.[field];
              if (params.node.rowPinned) return '';
              return val ? val : '-';
            },
          };
        case 'productDate': //生产日期
        case 'deadline': //有效期至
        case 'recepitsDate': //采购时间
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              const field = item.field;
              const val = t?.[field];
              if (params.node.rowPinned) return '';
              return val
                ? moment(val).format(DateTimeFormatSimple)
                : '-'
            },
          };
        case 'count': //采购数量
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
                lineHeight: params.node.rowPinned ? '40px' : '56px',
              }
            },
            cellRendererFramework: function getCount(params: any) {
              const t = params.data
              return <><span>{t?.count}</span><span>{t.unit}</span></>
            },
          };
        case 'unitPrice': //进价
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: (params: any) => {
              return {
                textAlign: 'right',
                lineHeight: params.node.rowPinned ? '40px' : '56px',
              }
            },
            cellRendererFramework: (params: any) => {
              const t = params.data
              const field = item.field;
              const val = Number(t?.[field]);
              return !KFGZZCKLRSJData ? '***' : (val
                ? parseFloat((val as unknown) as string).toFixed(5)
                : 0)
            },
          };
        case 'retailPrice': //销售价
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
                lineHeight: params.node.rowPinned ? '40px' : '56px',
              }
            },
            cellRendererFramework: (params: any) => {
              const t = params.data
              const field = item.field;
              const val = Number(t?.[field]);
              return val
                ? parseFloat((val as unknown) as string).toFixed(5)
                : 0
            },
          };
        case 'changeUnitPrice': //变动金额(进价)
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: (params: any) => {
              return {
                textAlign: 'right',
                lineHeight: params.node.rowPinned ? '40px' : '56px',
              }
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned){
                if(cell?.totalChangePrice && cell?.totalChangePrice>0){
                  return cell?.totalChangePrice ;
                }else{
                  return '';
                }


              }
              const t = params.data;
              return !KFGZZCKLRSJData ? '***' : (t.unitPrice * t.count
                ? parseFloat(((t.unitPrice * t.count) as unknown) as string).toFixed(
                  2
                )
                : 0 )
            },
          };
        default:
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
          };
      }
    })
  )
}
